import type { DealPromptContextType, DealPromptFilters } from '../types';
import { dealPromptContextTypes } from '../types';

type VisibleFilters = (keyof Omit<DealPromptFilters, 'phrase'>)[];

export const getVisibleFilters = (contextType: DealPromptContextType): VisibleFilters => {
  const domainsAndAppsFilters: VisibleFilters = ['format_and_devices', 'geography', 'goal'];
  const audienceFilters: VisibleFilters = ['region', 'country', 'user_location', 'demographic', 'uniqueUsersReach'];

  const filtersToContextTypeMap: Record<DealPromptContextType, VisibleFilters> = {
    [dealPromptContextTypes.DOMAINS]: domainsAndAppsFilters,
    [dealPromptContextTypes.APPS]: domainsAndAppsFilters,
    [dealPromptContextTypes.AUDIENCE]: audienceFilters,
    [dealPromptContextTypes.ALL]: domainsAndAppsFilters,
  };

  return filtersToContextTypeMap[contextType];
};
